import { intl } from "LocaleWrapper";
import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Select } from "@cofano/cck";
import z from "zod";
import { createWidgetVisual } from "view/dashboard/widgets/visuals/types";

const ALIGNMENTS = [ "left", "center" ] as const;

type Alignment = (typeof ALIGNMENTS)[number];

export default createWidgetVisual({
	valueType: "text",
	label: intl.formatMessage({ id: "WIDGET_TEXT" }),
	configSchema: z.object({
		align: z.enum(ALIGNMENTS).default("left"),
	}),

	render: ({ value, config }) => (
		<p style={{ textAlign: config.align, margin: 0 }}>{value}</p>
	),

	form: ({ prefix }) => {
		const { control } = useFormContext();

		return <FormGroup label={intl.formatMessage({ id: "ALIGNMENT" })} labelPlacement="left">
			<Controller
				name={`${prefix}.align`}
				control={control}
				render={({ field }) => (
					<Select<Alignment, false>
						disableSearch
						clearable={false}
						fetchOptions={[ ...ALIGNMENTS ]}
						getOptionLabel={option => intl.formatMessage({ id: option === "left" ? "ALIGN_LEFT" : "ALIGN_CENTER" })}
						value={(field.value as Alignment) ?? "left"}
						onChange={option => field.onChange(option ?? "left")} />
				)} />
		</FormGroup>;
	},
});
